import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.function.name";
/** @jsx jsx */

import { jsx } from 'theme-ui';
import React from 'react';
import { useCurrentDoc } from 'docz';
import * as styles from './styles';
import { NavLink } from '../NavLink';
import { ChevronDown } from '../Icons';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var NavGroup = function NavGroup(_ref) {
  var item = _ref.item,
      sidebarRef = _ref.sidebarRef;
  var currentDoc = useCurrentDoc();
  var currentDocRef = React.useRef();
  var name = item.name,
      menu = item.menu;

  var _React$useState = React.useState(currentDoc.menu === name),
      subheadingsVisible = _React$useState[0],
      setShowsubheadings = _React$useState[1];

  var toggleSubheadings = function toggleSubheadings() {
    return setShowsubheadings(!subheadingsVisible);
  };

  React.useEffect(function () {
    if (sidebarRef.current && currentDocRef.current) {
      sidebarRef.current.scrollTo(0, currentDocRef.current.offsetTop);
    }
  }, []);
  return jsx("div", {
    sx: styles.wrapper,
    "data-testid": "nav-group"
  }, jsx("div", {
    sx: styles.title,
    onClick: toggleSubheadings
  }, item.name, jsx(ChevronDown, {
    sx: styles.chevron({
      active: subheadingsVisible
    })
  })), jsx("div", {
    sx: styles.sublinkWrapper,
    "data-testid": "nav-group-links"
  }, menu && subheadingsVisible && menu.map(function (menu) {
    if (currentDoc.route === menu.route) {
      return jsx(NavLink, {
        key: menu.id,
        item: menu,
        ref: currentDocRef
      }, menu.name);
    }

    return jsx(NavLink, {
      key: menu.id,
      item: menu
    }, menu.name);
  })));
};

if (typeof NavGroup !== 'undefined' && NavGroup && NavGroup === Object(NavGroup) && Object.isExtensible(NavGroup) && !NavGroup.hasOwnProperty('__filemeta')) {
  Object.defineProperty(NavGroup, '__filemeta', {
    configurable: true,
    value: {
      name: "NavGroup",
      filename: "node_modules/gatsby-theme-docz/src/components/NavGroup/index.js"
    }
  });
}